import { __rest } from 'tslib';
import { jsx, jsxs } from 'react/jsx-runtime';
import { ThemeProvider } from '@emotion/react';
import MuiAlert from '@mui/material/Alert';
import alertTheme from './Alert.theme.js';
import { Info, Error, Warning, CheckCircle } from '@mui/icons-material';
import AlertTitle from '../AlertTitle/AlertTitle.js';

/**
 * https://mui.com/api/alert/
 */
const CustomAlertIcon = ({ severity }) => {
    switch (severity) {
        case 'success':
            return jsx(CheckCircle, { fontSize: "inherit" });
        case 'warning':
            return jsx(Warning, { fontSize: "inherit" });
        case 'error':
            return jsx(Error, { fontSize: "inherit" });
        case 'info':
        default:
            return jsx(Info, { fontSize: "inherit" });
    }
};
const Alert = (_a) => {
    var { children, title, severity } = _a, props = __rest(_a, ["children", "title", "severity"]);
    return (jsx(ThemeProvider, Object.assign({ theme: alertTheme }, { children: jsxs(MuiAlert, Object.assign({ icon: jsx(CustomAlertIcon, { severity: severity }) }, props, { severity: severity }, { children: [title && jsx(AlertTitle, { children: title }), children] })) })));
};

export { Alert as default };
//# sourceMappingURL=Alert.js.map
